"use client";

import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="924" id="direkter-draht" className="relative dark bg-background py-32 px-4 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "radial-gradient(circle at 20% 30%, var(--foreground) 1px, transparent 1px), radial-gradient(circle at 70% 80%, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "40px 40px, 60px 60px"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative max-w-3xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex justify-center mb-6" aria-hidden="true">
          <svg width="60" height="24" viewBox="0 0 60 24" fill="none" className="opacity-40" style={{
          color: "var(--primary)"
        }}>
            <path d="M30 12 Q22 4, 14 8 Q10 10, 6 12 M30 12 Q38 4, 46 8 Q50 10, 54 12 M30 12 L30 20" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" fill="none" />
            <circle cx="30" cy="12" r="1.5" fill="currentColor" />
            <ellipse cx="14" cy="8" rx="2.5" ry="1.2" fill="currentColor" opacity="0.6" />
            <ellipse cx="46" cy="8" rx="2.5" ry="1.2" fill="currentColor" opacity="0.6" />
          </svg>
        </div>

        {}
        <div className="relative rounded-lg p-10 sm:p-14 lg:p-20 bg-card/60 backdrop-blur-sm" style={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "color-mix(in srgb, var(--primary) 30%, transparent)"
      }}>
          {}
          <div className="flex justify-center mb-8">
            <div className="flex items-center justify-center" style={{
            color: "var(--primary)"
          }}>
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M8 14 L25 26 L42 14" />
                <rect x="8" y="14" width="34" height="24" rx="1" />
                <path d="M8 38 L20 26" />
                <path d="M42 38 L30 26" />
                <path d="M16 20 L34 20" opacity="0.5" />
                <path d="M16 24 L30 24" opacity="0.5" />
              </svg>
            </div>
          </div>

          {}
          <p className="text-center text-xs sm:text-sm uppercase tracking-[0.25em] mb-6 font-default" style={{
          color: "var(--primary)"
        }}>
            · Direkter Draht ·
          </p>

          {}
          <h2 className="font-serif font-default text-center text-foreground mb-6 leading-tight" style={{
          fontSize: "clamp(2rem, 4vw, 3rem)"
        }}>
            Bereit für Ihr perfektes Raumklima?
          </h2>

          {}
          <p className="text-center text-muted-foreground mb-10 max-w-xl mx-auto leading-relaxed" style={{
          fontSize: "18px"
        }}>
            Schreiben Sie uns Ihr Anliegen. Wir melden uns zeitnah bei Ihnen zurück, um Ihr Projekt zu besprechen.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="rounded-lg px-8 h-12 bg-primary text-primary-foreground hover:bg-primary/90 shadow transition-all hover:shadow-md">
              <Link to="/ContactPage">
                <Mail className="size-4" />
                Jetzt anfragen
              </Link>
            </Button>

            <Link to="mailto:info@naber-conduct.com" className="font-serif italic text-base sm:text-lg transition-opacity hover:opacity-70" style={{
            color: "var(--primary)"
          }}>
              Oder schreiben Sie uns —— info@naber-conduct.com
            </Link>
          </div>
        </div>

        {}
        <div className="flex justify-center mt-6" aria-hidden="true">
          <svg width="60" height="24" viewBox="0 0 60 24" fill="none" className="opacity-40 rotate-180" style={{
          color: "var(--primary)"
        }}>
            <path d="M30 12 Q22 4, 14 8 Q10 10, 6 12 M30 12 Q38 4, 46 8 Q50 10, 54 12 M30 12 L30 20" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" fill="none" />
            <circle cx="30" cy="12" r="1.5" fill="currentColor" />
            <ellipse cx="14" cy="8" rx="2.5" ry="1.2" fill="currentColor" opacity="0.6" />
            <ellipse cx="46" cy="8" rx="2.5" ry="1.2" fill="currentColor" opacity="0.6" />
          </svg>
        </div>
      </div>
    </section>;
}